import { Tooltip } from '@tempmee/react';
import { SolidInformationCircleIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

// Re-exported from a JSX-free module so importers that only need the status
// constant (e.g. userReducer) don't transitively pull this file's design-system
// JSX into their import graph. See constants.ts.
export { WC_MANAGEMENT_STATUS } from './constants';

export const headerUnselectedTitles = ['Office Name', 'State', 'Worker Type'];

export const headerConfirmedWorkerTypesTitles = [
  'Office Name',
  'State',
  'Request Date',
  'Set Date',
  'Worker Type',
];

export const pendingHeaderTitles = [
  'Office Name',
  'State',
  'Request Date',
  <span key="workerTypeRequested">
    Worker Type Requested
    <span style={{ marginLeft: '5px' }}>
      <Tooltip
        content={
          <>
            The worker type reflects the worker type selected by the office completing this shift.
            <br />
            <br />
            {'\u2022  '}
            &ldquo;Employed&rdquo; means that the professional will be engaged as an
            employee of our PEO.
            <br />
            <br />
            {'\u2022  '}
            &ldquo;Contracted&rdquo; means that an independent contractor has chosen to offer
            professional
            services through the GoTu platform.
          </>
        }
      >
        <SolidInformationCircleIcon color={colors.neutral[300]} />
      </Tooltip>
    </span>
  </span>,
  'Approval',
];

export const getInitialTab = (requests) => {
  if (requests?.pending?.length > 0) return 'pending-requests';
  if (requests?.unselected?.length > 0) return 'unselected';
  return 'confirmed';
};
